@if (form(); as formGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="formGroup">
    <div>
      <pt-iso-date-selector
        class="w-full"
        placeholder="Date of Injury"
        formControlName="accidentDate"
        [required]="true"
      />
      @if (formGroup.accidentDateRequiredError) {
        <span class="text-xs text-red-500">This field is required</span>
      }
    </div>

    <div>
      <p class="font-bold">
        Did the accident involve a moving motor vehicle on a public road? *
      </p>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="involvesVehicle"
        required
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (formGroup.involvesVehicleRequiredError) {
        <mat-error>This field is required</mat-error>
      }
      <pr-information-box>
        This Includes being a driver or passenger, in a stationary vehicle,
        struck by a moving vehicle or travelling for work purposes. This doesn't
        include off-road or non-motorised vehicles, or to a stationary vehicle
        that is being repaired.
      </pr-information-box>
    </div>

    <div>
      <div class="flex justify-between">
        <p class="font-bold">Is this a claim for treatment injury?</p>
        <p class="!text-xs text-gray-500">Optional</p>
      </div>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="medicalTreatmentInjury"
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <pr-information-box>
        <div>
          A treatment injury is when your patient has an injury caused by
          treatment from a registered health professional. See
          <a
            href="https://www.acc.co.nz/"
            rel="noopener noreferrer"
            target="_blank"
          >
            ACC's website
            <mat-icon class="icon-sm">open_in_new</mat-icon>
          </a>
          to learn more about treatment injuries.
        </div>
      </pr-information-box>
    </div>

    <mat-form-field class="w-full">
      <mat-label>Accident Scene</mat-label>
      <mat-select formControlName="accidentSceneCode" required>
        @for (option of sceneOptions; track option.code) {
          <mat-option [value]="option.code">{{ option.label }}</mat-option>
        }
      </mat-select>
      @if (formGroup.accidentSceneCodeRequiredError) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>

    <div>
      <mat-form-field class="mb-2 w-full">
        <mat-label>Accident Location</mat-label>
        <mat-select formControlName="accidentLocationCode" required>
          @for (option of geoLocationOptions; track option.code) {
            <mat-option [value]="option.code">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (formGroup.accidentLocationCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
      <pr-information-box>
        Please specify the city or district the accident occurred in. There are
        also options for overseas, in the air or at sea.
      </pr-information-box>
    </div>

    <div>
      <mat-form-field class="mb-2 w-full">
        <mat-label>
          Describe the events or circumstances which led to the injury
        </mat-label>
        <textarea
          matInput
          formControlName="causeOfAccident"
          rows="3"
          required
        ></textarea>
        @if (formGroup.causeOfAccidentRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
      <pr-information-box>
        E.g. They were standing on a chair putting items on a shelf and fell,
        landing on their ankle.
      </pr-information-box>
    </div>

    <div>
      <p class="font-bold">
        Did the accident happen during sports or recreation? *
      </p>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="sportingInjury"
        required
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (formGroup.sportingInjuryRequiredError) {
        <mat-error>This field is required</mat-error>
      }
    </div>

    @if (formGroup.displaySportNameCode) {
      <mat-form-field class="w-full">
        <mat-label>Sport/Recreation Activity</mat-label>
        <mat-select formControlName="sportNameCode" required>
          @for (option of sportsOptions; track option.code) {
            <mat-option [value]="option.code">{{ option.label }}</mat-option>
          }
        </mat-select>
        @if (formGroup.sportNameCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    }

    <mat-form-field class="w-full">
      <mat-label>Additional Comments About the Injury</mat-label>
      <textarea matInput formControlName="injuryComments" rows="3"></textarea>
      <mat-hint align="end">Optional</mat-hint>
    </mat-form-field>
  </form>
}
